module.exports = __webpack_public_path__ + "static/9-Dish w_loose flower sculpture-close up-453dcb82675e66aa75ae60d4a594c01e.jpg";